<script lang="ts" setup>
import type { PxlIconName } from "@/common/components/U/Icon";
import { ShapeType } from "@/telestrations/types/canvas";

const { t } = useI18n();
const props = defineProps<{
  tool: Tool;
}>();

const toolsStore = useToolsStore();

const isSelected = computed(() => {
  return toolsStore.selectedTool === props.tool;
});

function onClick() {
  toolsStore.selectTool(props.tool);
}

const iconsMap: Record<Tool, PxlIconName> = {
  selection: "cursor",
  [ShapeType.Line]: "free-draw",
  [ShapeType.Rectangle]: "rectangle",
  [ShapeType.Ellipse]: "ellipse",
  [ShapeType.Arrow]: "arrow-top-right",
  [ShapeType.Text]: "text",
  [ShapeType.Spotlight]: "spotlight",
};

const i18nLabelsMap: Record<Tool, string> = {
  selection: "labels.select",
  [ShapeType.Line]: "labels.free_draw",
  [ShapeType.Rectangle]: "labels.rectangle",
  [ShapeType.Ellipse]: "labels.ellipse",
  [ShapeType.Arrow]: "labels.arrow",
  [ShapeType.Text]: "labels.text",
  [ShapeType.Spotlight]: "labels.spotlight",
};
</script>

<template>
  <TButton
    :variant="isSelected ? 'primary' : 'clean'"
    class="hover:bg-blue-500"
    :icon="iconsMap[props.tool]"
    :tooltip="t(i18nLabelsMap[props.tool])"
    @click="onClick"
  />
</template>
